import styled from 'styled-components';

import CrossDark from '../../../components/Images/CrossDark';
import CrossIcon from '../../../components/Images/CrossIcon';

const Container = styled.div`
  padding: 48px 24px;
  margin-bottom: 24px;
  background-color: var(--Dove);

  @media (max-width: 600px) {
    padding: 32px 16px;
  }
`;
const SubSectionTitle = styled.div`
  font-size: 20px;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 8px;
`;
const InlineInfoText = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text500);
  margin-bottom: 16px;
`;
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: unset;
  }
`;
const InputContainer = styled.div`
  width: 49%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;
const FileContainer = styled.div`
  padding: 14px;
  border-radius: 4px;
  border: ${({ hasError }) =>
    hasError ? 'solid 1px var(--Punch500)' : 'solid 1px var(--Azure500)'};
  background-color: white;
`;
const FilePlaceHolder = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: var(--Azure500);
`;
const ProgressDiv = styled.div`
  padding: 14px 16px;
  background-color: var(--Grey100);
  border-radius: 4px;
  display: flex;
  align-items: center;
`;
const ProgressPercent = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: var(--Text500);
  margin-right: 10px;
`;
const LinearProgress = styled.div`
  width: calc(100% - 140px);
  height: 8px;
  border-radius: 2px;
  background-color: var(--Grey900);
  overflow: hidden;
  margin-right: 16px;
`;
const ProgressBar = styled.div`
  height: 100%;
  width: ${({ value }) => value}%;
  background-color: var(--Azure500);
`;

const StyledCrossIcon = styled(CrossIcon)`
  z-index: 2;
  cursor: pointer;
`;
const InvalidDetailsDiv = styled.p`
  margin-top: 5px;
  color: ${({ value }) => value};
`;

const HoverActions = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  display: none;
  width: 100%;
  justify-content: flex-end;
  background-image: linear-gradient(
    to left,
    var(--Dove),
    var(--Dove),
    rgba(255, 255, 255, 0)
  );
  padding: 10px 8px;
`;
const FileNameDiv = styled.div`
  display: flex;
  border-radius: 2px;
  border: solid 1px var(--Grey900);
  padding: 11px 12px 9px 12px;
  position: relative;
  &:hover ${HoverActions} {
    display: flex;
  }
`;
const FileIconDiv = styled.div`
  margin-right: 8px;
`;

const FileDetailsDiv = styled.div``;

const FileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: var(--Text500);
`;
const DownloadButton = styled.a`
  outline: none;
  border: none;
  border-radius: 4px;
  background-color: var(--Azure500);
  padding: 8px 12px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  margin-right: 8px;
  cursor: pointer;
`;
const DownloadPdfButton = styled.button`
  outline: none;
  border: none;
  border-radius: 4px;
  background-color: var(--Azure500);
  padding: 8px 12px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  margin-right: 8px;
  cursor: pointer;
`;
const UploadButton = styled.button`
  outline: none;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Text500);
  background: none;
  cursor: pointer;
`;
const SaveButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  opacity: ${({ isValid }) => (isValid ? '1' : '0.3')};
  border-radius: 4px;
  background-color: var(--Azure500);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  padding: 16px;
  width: 200px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;
const HelpText = styled.div`
  font-size: 18px;
  line-height: 32px;
  color: var(--Text700);
  margin-top: 38px;
  margin-bottom: 26px;
`;
const AgreeCTA = styled.div`
  display: flex;
  align-items: center;
  width: 70%;

  margin-right: 16px;

  span {
    font-size: 16px;
    line-height: 1.5;
    text-align: left;
    color: var(--Text500);
  }
  span > span {
    text-decoration: underline;
    color: var(--azure);
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;
const ConfirmAndSubmit = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
const RadioIcon = styled.div`
  margin-bottom: 20px;
  width: 16px;
  height: 16px;
  border: solid 1px var(--Text500);
  padding: 3px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  align-items: center;
  background-color: ${({ active }) =>
    active ? 'var(--Text500)' : 'var(--Grey300)'};
`;

const CheckBox = styled.div`
  width: 16px;
  height: 16px;
  padding: 3px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  background-color: ${({ active }) =>
    active ? 'var(--Azure500)' : 'var(--Grey500)'};
`;
const HR = styled.div`
  background-color: var(--Grey900);
  height: 2px;
  margin-bottom: 24px;
  margin-top: 24px;
`;
const UploadLabel = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 4px;

  @media (max-width: 600px) {
    margin-top: 16px;
  }
`;
const UploadSubLabel = styled.div`
  font-size: 12px;
  line-height: 1.33;
  text-align: left;
  color: var(--Text500);
  margin-bottom: 8px;
`;

const SectionHeading = styled.div`
  font-size: 24px;
  line-height: 1.2;
  text-align: center;
  color: var(--Text700);
  margin-bottom: 16px;
  font-weight: bold;
`;
const CheckSampleBtn = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  color: var(--Text500);
  cursor: pointer;
  font-size: 12px;
  width: max-content;
  & svg {
    margin-left: 4px;
  }
`;
const AddMoreCharacterBtn = styled.button`
  width: 100%;
  border: solid 1px var(--Grey900);
  background-color: var(--Grey300);
  border-radius: 4px;
  padding: 12px 16px;
  margin: 8px auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #0d15364d;
  font-size: 16px;

  &:disabled {
    cursor: not-allowed;
  }

  & svg {
    margin-right: 8px;
  }
`;
const ImportantPlotlinesBtn = styled.button`
  width: 100%;
  border: solid 1px var(--Grey900);
  background-color: var(--Grey300);
  border-radius: 4px;
  padding: 12px 16px;
  margin: 8px auto;
  cursor: pointer;
  text-align: left;

  h4 {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    margin-bottom: 8px;
    color: var(--Text500);
  }

  p {
    color: var(--Text100);
    font-size: 16px;
  }

  ${({ hasError }) =>
    hasError &&
    `
    border-color: red;
  `}
`;

const BackBtn = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  color: var(--text);
`;

const AddMorePlotlinesBtn = styled(AddMoreCharacterBtn)`
  color: var(--Azure500);
  background-color: #068ae21a;
  border: 1px solid #068ae21a;
  margin: 32px auto;

  &:disabled {
    cursor: not-allowed;
  }

  & svg path {
    fill: var(--Azure500);
    fill-opacity: 1;
  }

  @media (max-width: 600px) {
    padding: 12px;
    margin: 0px;
  }
`;
const SaveBtn = styled.button`
  display: block;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  border-radius: 4px;
  background-color: var(--Azure500);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  padding: 16px;
  width: 140px;
  margin-left: auto;
  opacity: ${({ isValid }) => (isValid ? '1' : '0.3')};

  @media (max-width: 600px) {
    padding: 12px;
    width: 100px;
  }
`;
const ActionContainer = styled.div`
  transition: all 0.2s;

  @media (max-width: 600px) {
    margin-top: 16px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    column-gap: 16px;
  }
`;

const CharacterBtn = styled(ImportantPlotlinesBtn)`
  ${({ hasError }) => hasError && `border-color: red;`}

  & p span {
    color: #54b585;
  }
`;

const RightCrossIcon = styled(CrossDark)`
  float: right;
  cursor: pointer;
`;
const ExtraNote = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: var(--Text500);
  margin-bottom: 4px;
`;
export {
  CheckSampleBtn,
  SectionHeading,
  UploadSubLabel,
  UploadLabel,
  HR,
  RightCrossIcon,
  RadioIcon,
  ConfirmAndSubmit,
  AgreeCTA,
  CharacterBtn,
  ActionContainer,
  SaveBtn,
  BackBtn,
  ImportantPlotlinesBtn,
  AddMoreCharacterBtn,
  AddMorePlotlinesBtn,
  Container,
  SubSectionTitle,
  InlineInfoText,
  FlexContainer,
  InputContainer,
  FileContainer,
  FilePlaceHolder,
  ProgressDiv,
  ProgressPercent,
  LinearProgress,
  ProgressBar,
  StyledCrossIcon,
  InvalidDetailsDiv,
  HoverActions,
  FileNameDiv,
  FileIconDiv,
  FileDetailsDiv,
  FileName,
  DownloadButton,
  DownloadPdfButton,
  UploadButton,
  SaveButton,
  HelpText,
  CheckBox,
  ExtraNote,
};
